// extracted by mini-css-extract-plugin
export default {"formWrapper":"Login_formWrapper__phWzp","loginForm":"Login_loginForm__fuwzb","rememberWrapper":"Login_rememberWrapper__TUOZt"};